module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("khkQr"))).then(() => parcelRequire('cvs7o'));